package org.multipaz.wallet.shared

class WalletBackendNonceException(message: String? = null): WalletBackendException(message)